import { Link } from "react-router-dom";
import { CalendarDays, Inbox, PenSquare, ShoppingBag } from "lucide-react";
import { Button } from "@/components/ui/button";

// Site page = technical settings only. Modules are configured in the editor, the data they receive lives in the CRM: here only the way there.
function Card({ icon: Icon, title, text, children, testid }) {
  return (
    <div className="rounded-lg border border-slate-200 p-4 space-y-3" data-testid={testid}>
      <p className="flex items-center gap-2 text-sm font-semibold text-slate-900"><Icon size={15} className="text-slate-500" />{title}</p>
      <p className="text-xs text-slate-500">{text}</p>
      <div className="flex flex-wrap gap-2">{children}</div>
    </div>);
}

export default function SiteModulesHub({ site }) {
  const tid = site.client.id;
  const editor = `/projects/${site.project.id}?moduli=1`;
  const crm = (tab) => `/crm/${tid}?tab=${tab}`;
  const B = ({ to, testid, children, primary }) => <Button asChild size="sm" variant={primary ? "default" : "outline"} data-testid={testid}><Link to={to}>{children}</Link></Button>;
  return (
    <div className="space-y-4" data-testid="site-modules-hub">
      <p className="text-sm text-slate-600">Questa pagina contiene solo le impostazioni tecniche del sito. Moduli e servizi si configurano nell'<b>editor</b>; prenotazioni, richieste e ordini ricevuti si gestiscono nel <b>CRM</b>.</p>
      <div className="grid gap-3 md:grid-cols-3">
        <Card icon={CalendarDays} title="Prenotazioni" text="Widget, servizi, giorni e orari, risorse e campi: nell'editor (seleziona la sezione prenotazioni). Prenotazioni ricevute: Calendario CRM." testid="hub-bookings">
          <B to={editor} testid="hub-bookings-editor" primary><PenSquare size={13} className="mr-1" />Configura nell'editor</B>
          <B to={crm("calendar")} testid="hub-bookings-crm"><CalendarDays size={13} className="mr-1" />Apri Calendario CRM</B>
        </Card>
        <Card icon={Inbox} title="Moduli di contatto" text="Campi e consenso del modulo: nell'editor (sezione modulo › «Campi del modulo»). Messaggi ricevuti: Richieste nel CRM." testid="hub-forms">
          <B to={editor} testid="hub-forms-editor" primary><PenSquare size={13} className="mr-1" />Configura nell'editor</B>
          <B to={crm("leads")} testid="hub-forms-crm"><Inbox size={13} className="mr-1" />Apri Richieste CRM</B>
        </Card>
        <Card icon={ShoppingBag} title="Negozio" text="Ordini e abbonamenti ricevuti: nel CRM. Catalogo, sconti e spedizioni: scheda «Negozio» qui accanto (in arrivo nell'editor)." testid="hub-shop">
          <B to={crm("orders")} testid="hub-shop-orders">Apri Ordini CRM</B>
          <B to={crm("subscriptions")} testid="hub-shop-subs">Apri Abbonamenti CRM</B>
        </Card>
      </div>
    </div>);
}
